const SAVE = "SAVE_INFO_PRODUCT";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}